import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import Rbac from '../../../components/Rbac';
import loginHistory from './loginHistory';
import tradeHistory from './tradeHistory';
import userAssets from './userAssets';

const UserActivities = ({match}) => (
  <div className="dashboard-wrapper">
    <Switch>
      {Rbac.hasPermission('view_exchange-trades') ?
        <Redirect exact from={`${match.url}/`} to={`${match.url}/tradeHistory`}/> :
        Rbac.hasPermission('view_user-assets') ?
        <Redirect exact from={`${match.url}/`} to={`${match.url}/userAssets`}/> :
          <Redirect exact from={`${match.url}/`} to={`${match.url}/loginHistory`}/>
      }
      <Route path={`${match.url}/tradeHistory`} component={tradeHistory}/>
      <Route path={`${match.url}/userAssets`} component={userAssets}/>
      <Route path={`${match.url}/loginHistory`} component={loginHistory}/>
      <Redirect to="/error"/>
    </Switch>
  </div>
);

export default UserActivities;
